/**
 * DLQ row class for entitlement sync failures.
 */
export enum EntitlementSyncFailureClassEnum {
  PERMANENT = 'permanent',
  TRANSIENT = 'transient',
}
